import { Suspense } from "react";
import { createRoot } from "react-dom/client";

import store from "./redux/store";

import App from "./components/App";
import Root from "./components/Root";
import LoadingIcon from "./components/LoadingIcon";
import { setupAjax } from "./utils/setup_ajax_csrf";
import "../stylesheets/styles.scss";
import "./i18n";

setupAjax();

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Suspense fallback={<LoadingIcon default />}>
    <Root store={store}>
      <App />
    </Root>
  </Suspense>,
);
